<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th
            v-for="(column, key) in columns"
            :class="'text-' + column.align"
            :key="key"
            @click="sortBy(column)"
          >
            <div class="table-header">
              <div v-if="!column.lang" class="table-header-title">
                {{
                  (column.key + (column.object ? "_" + column.object : ""))
                    | setText(column.title)
                }}
              </div>
              <div v-else class="table-header-title">
                {{ column.label | setText }}
              </div>
              <div v-if="column.sortBy" class="table-header-sort">
                <span
                  :style="{
                    opacity:
                      sort.orderType === 'ACS' && sort.orderBy === column.sortBy
                        ? 1
                        : 0.4,
                  }"
                  class="ti-arrow-circle-up"
                ></span>
                <span
                  :style="{
                    opacity:
                      sort.orderType === 'DESC' &&
                      sort.orderBy === column.sortBy
                        ? 1
                        : 0.4,
                  }"
                  class="ti-arrow-circle-down"
                ></span>
              </div>
            </div>
          </th>
        </slot>
      </thead>
      <!-- v-model="dataArray" -->
      <tbody
        :move="onMove"
        v-if="dataArray.length"
        :tag="'tbody'"
        @change="positionItem"
      >
        <tr width="auto" v-for="(item, index) in data" :key="index">
          <slot v-if="!holidays[item['date']]" :row="item">
            <td
              v-for="(column, index) in columns"
              :align="column.align ? column.align : 'left'"
              :key="index"
              :class="`${column.full === true ? 'full' : ''}`"
            >
              <div class="text-right" v-if="column.remove || column.detail">
                <button
                  v-if="column.detail === true"
                  @click="openObject(item, card)"
                  class="btn btn-sm"
                >
                  <span class="ti-pencil"></span>
                </button>

                <button
                  v-if="column.remove === true"
                  @click="removeItem(item.id)"
                  class="btn btn-sm btn-danger ml-1"
                >
                  <span class="ti-trash"></span>
                </button>
              </div>

              <div v-else-if="column.inputSet === true">
                <input
                  class="input"
                  v-model="item[column.key]"
                  @input="setUpdate(item, column.key)"
                />
              </div>
              <div v-else-if="column.key === 'path'">
                <a :href="item[column.key]" target="_blank">{{
                  "Скачать" | setText("download")
                }}</a>
              </div>

              <div v-else-if="column.input">
                <span>
                  <input
                    v-model="item[column.key]"
                    :type="column.input"
                    class="form-control"
                  />
                </span>
              </div>

              <div v-else-if="column.checkbox === true">
                <checkbox
                  v-if="!simple"
                  v-model="val"
                  :value="item.id"
                  color="#ffc107"
                  :id="`check_${item.id}`"
                >
                  <span v-html="itemValue(item, column)"></span>
                </checkbox>
                <div v-if="simple" class="radiobox radio-style-1">
                  <input
                    v-if="simple"
                    :id="card + 'item-' + item.id"
                    :value="item.id"
                    :name="card ? card : 'selector'"
                    v-model="val"
                    type="radio"
                  />
                  <label :for="card + 'item-' + item.id">
                    <span v-html="itemValue(item, column)"></span>
                  </label>
                  <span class="radio-item">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <circle r="8" cx="50%" cy="50%" class="_circle-1"></circle>
                      <circle r="8" cx="50%" cy="50%" class="_circle-2"></circle>
                      <circle r="8" cx="50%" cy="50%" class="_circle-3"></circle>
                    </svg>
                  </span>
                </div>
              </div>

              <div v-else-if="column.dateFormat === true">
                <span v-if="column.object && item[column.key][column.object]">
                  {{ item[column.key][column.object] | dateFormat }}
                </span>

                <span v-else> {{ item[column.key] | dateFormat }}</span>
              </div>
              <div v-else-if="column.dateTimeFormat === true">
                <span v-if="column.object && item[column.key][column.object]">
                  {{ item[column.key][column.object] | dateTimeFormat }}
                </span>
                <span v-else> {{ item[column.key] | dateTimeFormat }}</span>
              </div>
              <div v-else-if="column.image === true">
                <img
                  v-if="itemValue(item, column)"
                  :src="itemValue(item, column)"
                  :alt="`img`"
                  class="img"
                />
              </div>
              <div v-else-if="column.timer === true">
                <timer :item="item" />
              </div>

              <div v-else-if="column.subobject && column.object">
                {{ item[column.object][column.subobject][column["key"]] }}
              </div>
              <div v-else>
                <!-- <span
                  v-if="index == 0 && drag === true"
                  class="ti-exchange-vertical text-info"
                ></span> -->

                <span
                  v-if="
                    !column.key_type &&
                    column.object &&
                    column.key &&
                    item[column.key] &&
                    column['disableLink'] !== true
                  "
                  @click="
                    openObject(
                      item[column.key],
                      column.keyAs ? column.keyAs : column.key,
                      'item_'
                    )
                  "
                  class="link text-info"
                >
                  {{ itemValue(item, column) }}
                </span>
                <span
                  v-else-if="column.key_type && item[column.key]"
                  @click="
                    openObject(
                      { id: item[column.key].id },
                      item[column.key_type],
                      'item_'
                    )
                  "
                  class="link text-info"
                >
                  {{ itemValue(item, column) }} # {{ item[column.key_type] }}
                </span>
                <span v-else v-html="itemValue(item, column)"> </span>
              </div>
            </td>
          </slot>
          <template v-else>
            <td>
              {{ item["date"] | dateFormat }}
            </td>
            <td :colspan="columns.length - 1" v-if="holidays">
              {{ holidays[item["date"]]["title"] }}.
              {{ holidays[item["date"]]["description"] }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import draggable from "vuedraggable";
import timer from "../components/Timer";
import { errorNotify } from "@/plugins/functions";
export default {
  components: {
    timer,
    draggable,
  },

  data() {
    return {
      timerInput: {},
      noImage: require("@/assets/img/no-photo-available.png"),
      // val: [],
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
    };
  },
  name: "paper-table",
  props: {
    drag: {
      default: false,
    },
    card: {
      default: null,
    },
    additionalId: {
      default: null,
    },
    current_page: {
      default: 1,
    },
    columns: Array,
    data: Array,
    holidays: Object,
    type: {
      type: String,
      default: "striped",
    },
    itemLink: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    simple: {
      default: false,
    },
    subTitle: {
      type: String,
      default: "",
    },
    removeItem: {
      default: function () {},
    },
    items: {
      default: function () {},
    },
    value: {
      default: function () {
        return [];
      },
    },
    dataObject: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    ...mapState(["languages"]),
    tableClass() {
      return `table-${this.type}`;
    },
    val: {
      get() {
        let val;
        if (!this.simple) {
          val = [];
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id) {
              this.dataObject[this.value[i].id]["input_data"] =
                this.value[i].input_data;
              val.push(this.value[i].id);
            }
          }
        } else {
          val = this.value;
        }

        // console.log('object: ', this.dataObject);
        return val;
      },
      set(val) {
        let result;
        if (!this.simple) {
          result = [];
          for (let i = 0; i < val.length; i++) {
            if (this.dataObject[val[i]]) {
              result.push(this.dataObject[val[i]]);
            }
          }
        } else {
          result = [this.dataObject[val]];
        }
        //console.log(this.value);
        this.$emit("input", result);
      },
    },
    dataArray: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("changeData", val);
      },
    },
  },
  methods: {
    sortBy(column) {
      if (column.sortBy) {
        this.sort.orderType =
          this.sort.orderType === "ACS" && this.sort.orderBy === column.sortBy
            ? "DESC"
            : "ACS";
        this.sort.orderBy = column.sortBy;
        this.$emit("sortby", this.sort);
      }
    },
    openObject(item, card, prefix = "") {
      const element = `${prefix}${card}`;

      let link = item.id;

      if (this.additionalId) {
        link += "-" + this.additionalId;
      }

      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = link;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },

    // change(e) {},
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },

    itemValue(item, column) {
      let key = column.key;

      let titleObject = item[key];

      if (column.image === true) {
        return item[key] ? item[key] : this.noImage;
      }

      if (typeof item[key] === "object" && item[key] !== null) {
        if (Array.isArray(titleObject) && titleObject.length) {
          return titleObject
            .map((elem) => {
              if (column.object) {
                if (column.key === "translations") {
                  if (
                    !this.languages[elem["locale"]] ||
                    !elem[column.object] ||
                    elem[column.object] === "null"
                  ) {
                    return null;
                  }
                  return (
                    (column.key === "translations"
                      ? ' <span class="text-info">' +
                        elem["locale"] +
                        ": </span>"
                      : "") + elem[column.object]
                  );
                } else {
                  return elem[column.object];
                }
              }
            })
            .filter((el) => {
              return el;
            })
            .join(`<br/>`);
        } else if (column.object && titleObject[column.object]) {
          return titleObject[column.object];
        } else {
          return "-";
        }
      } else if (typeof item[key] === "boolean") {
        return item[key] ? "+" : "-";
      }

      if (item[key.toLowerCase()] || item[key.toLowerCase()] === 0) {
        return item[key.toLowerCase()];
      }

      // if (column.object && column.objectDefault) {
      //   return column.objectDefault;
      // }

      return "-";
    },
    setUpdate(item, column) {
      let data = {};

      if (this.timerInput[item["id"]]) {
        clearTimeout(this.timerInput[item["id"]]);
        this.timerInput[item["id"]] = null;
      }
      this.timerInput[item["id"]] = setTimeout(() => {
        let url = `${this.itemLink}/${item["id"]}`;
        data[column] = item[column];
        // this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            // this.$loading(false);
          });
      }, 800);
    },
    positionItem(val) {
      if (val && val.moved) {
        let moved = val.moved;
        let elementId = moved.element.id;
        let oldIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.oldIndex +
          1;
        let newIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.newIndex +
          1;
        let url = `lessonplans/${elementId}?change_position=1`;
        let data = {
          newIndex,
          oldIndex,
        };
        this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            this.$loading(false);
          });
      }
    },
    onMove() {
      return this.drag;
    },
  },
};
</script>
<style lang="scss">
tr {
  &:last-child {
    padding-right: 100px;
  }
}

.table {
  .img {
    width: 35px;
    height: 35px;
    object-fit: contain;
  }
  .radiobox{
    label{
      width: 100%;
    }
  }
}
.radiobox {
  display: flex;
  align-items: center;
  & > {
    display: block;

    input {
      margin-right: 10px;
    }
  }
}

.control-item {
  min-width: 110px;
  max-width: 110px;
  width: 110px;
}
</style>
